import axios from "axios";
import { COMMONCONSTANTS, GLOBALSETTINGS, TOKEN, USERINFO } from "../data/constants";
import { getAccessToken, getRefreshToken, isTokenValid, setAccessToken } from "./commonHelper";
const baseAPIUrl = process.env.REACT_APP_API_URL + "/api";

let refreshPromise: Promise<string> | null = null;

export const getValidAccessToken = async (): Promise<string> => {
    let token = getAccessToken();

    if (token && isTokenValid()) {
        return token;
    }

    // If refresh is already in progress, wait for it
    if (refreshPromise) {
        return refreshPromise;
    }
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
        throw new Error("No refresh token available");
    }

    refreshPromise = (async () => {
        try {
            // Plain axios, so apiClient's timeout does not apply — set it explicitly. Every
            // request that hits the 401-retry interceptor waits on this one, so an unbounded
            // hang here stalls all of them at once.
            const res = await axios.post(
                `${baseAPIUrl}/Portal/RefreshToken`,
                { refreshToken },
                {
                    headers: {
                        "Log-Source": COMMONCONSTANTS.LOG_SOURCE,
                    },
                    timeout: GLOBALSETTINGS.API_TIMEOUT_MS,
                }
            );

            const newAccessToken = res.data.accessToken;
            setAccessToken(newAccessToken);
            return newAccessToken;
        } catch (err) {
            console.log(err);
            localStorage.removeItem(TOKEN.ACCESSTOKEN);
            localStorage.removeItem(TOKEN.REFRESHTOKEN);
            onClearLocalStorage();
            window.location.href = "/signin";
        } finally {
            refreshPromise = null; // reset lock
        }
    })();

    return refreshPromise;
};

const onClearLocalStorage = () => {
    const preservedSessionValue = localStorage.getItem(USERINFO.SESSIONVALUE);
    localStorage.clear();
    if (preservedSessionValue !== null) {
        localStorage.setItem(USERINFO.SESSIONVALUE, preservedSessionValue);
    }
};
